<input
  type="radio"
  id="{{ id }}"
  [name]="groupId"
  class="custom-control-input"
  [formControl]="ctrl"
  [value]="radioValue"
/>
<label class="custom-control-label form-label" for="{{ id }}"
  >{{ label }} <ng-content select=".label"></ng-content
></label>
